import React, { useState, useEffect } from 'react'
import { Form, FormRow, Radio, Checkbox } from '@brainstud/react-helpers/form'
import * as helpers from './helpers'

const InputType = props => {
  const Type = props.type === 'multiple' ? Checkbox : Radio
  return <Type {...props} />
}

function useOptionsState(props) {
  const [options, setOptions] = useState([])

  useEffect(() => {
    const newOptions = []

    React.Children.forEach(props.children, (child, idx) => {
      if (child.type.displayName === 'QuizOption') {
        newOptions.push({
          ...child.props,
          id: `${idx + 1}`,
        })
      }
    })

    setOptions(newOptions)
  }, [props.children])

  return options
}

function useTypeState(options) {
  const [type, setType] = useState('single')

  useEffect(() => {
    const correctNo = options.reduce((acc, option) => option.correct ? acc + 1 : acc, 0)
    const newType = correctNo > 1 ? 'multiple' : 'single'

    setType(newType)
  }, [options])

  return type
}

function useCorrectOptionsState(options) {
  const [correctOptionsIds, setCorrectOptionsIds] = useState([])

  useEffect(() => {
    setCorrectOptionsIds(
      options.reduce((acc, item) => item.correct ? acc.concat(item.id) : acc, [])
    )
  }, [options])

  return correctOptionsIds
}

const QuizForm = props => {
  const options = useOptionsState(props)
  const type = useTypeState(options)
  const correctOptions = useCorrectOptionsState(options)

  const handleSingle = e => {
    const value = e.target.value
    const name = e.target.name

    // Check answers
    const picked = [].concat(value)
    const status = helpers.compareAnswers(type, correctOptions, picked)

    // Send form data to quiz
    props.onChange({
      [name]: value,
      ...status,
    })
  }

  const handleMultiple = e => {
    const value = e.target.value
    const name = e.target.name
    const input = props.value || []

    // Set / remove option from value array
    const newValue = input.indexOf(value) === -1
      ? input.concat(value)
      : input.filter(val => val !== value)

    // Check answers
    const picked = [].concat(newValue)
    const status = helpers.compareAnswers(type, correctOptions, picked)

    // Send form data to quiz
    props.onChange({
      [name]: newValue,
      ...status,
    })
  }

  const handleChange = e => {
    switch (type) {
      case 'multiple':
        handleMultiple(e)
        break

      case 'single':
        handleSingle(e)
        break

      default:
        return
    }
  }

  const isSelected = option => {
    switch (type) {
      case 'single':
        return props.value && option.id === props.value

      case 'multiple':
        return props.value && props.value.indexOf(option.id) !== -1

      default:
        return false
    }
  }

  const isMissing = option => {
    switch (type) {
      case 'single':
        // if option is correct
        // but not selected
        return props.submited
          && props.value
          && option.id === correctOptions[0]
          && props.value !== option.id

      case 'multiple':
        // if option is in correct
        // but not in value
        return props.submited
          && props.value
          && correctOptions.indexOf(option.id) > -1
          && props.value.indexOf(option.id) === -1

      default:
        return false
    }
  }

  const isCorrect = option => {
    switch (type) {
      case 'single':
        return props.submited
          && props.value
          && option.id === correctOptions[0]
          && props.value === option.id

      case 'multiple':
        return props.submited
          && props.value
          && correctOptions.indexOf(option.id) > -1
          && props.value.indexOf(option.id) !== -1

      default:
        return false
    }
  }

  const isWrong = option => {
    switch (type) {
      case 'single':
        return props.submited
          && props.value
          && option.id !== correctOptions[0]
          && props.value === option.id

      case 'multiple':
        return props.submited
          && props.value
          && correctOptions.indexOf(option.id) === -1
          && props.value.indexOf(option.id) !== -1

      default:
        return false
    }
  }

  // TODO add classNames to theme wrapper component
  return (
    <div style={{ pointerEvents: props.submited ? 'none' : 'auto' }}>
      <Form>
        {options.map(option => (
          <FormRow key={option.id}>
            <InputType
              type={type}
              name="answer"
              label={option.label || option.children}
              value={option.id}
              classNames={{
                isSelected: isSelected(option),
                isMissing: isMissing(option),
                isCorrect: isCorrect(option),
                isWrong: isWrong(option),
              }}
              onChange={handleChange}
            />
          </FormRow>
        ))}
      </Form>
    </div>
  )
}

export default QuizForm
